import React from 'react';
import ProfileScreen, { NavigationButton } from '@rahtab/system/lib/screens/ProfileScreen';
import {
  BottomSheet,
  ButtonBase,
  Card,
  CardCaption,
  CardContainer,
  Colors,
  getRadius,
  getSpacing,
  HorizontalLine,
  Text,
  TextBase,
} from '@rahtab/ui';
import HelpIcon from '@rahtab/ui/dist/icons/HelpIcon';
import PasswordIcon from '@rahtab/ui/dist/icons/PasswordIcon';
import ChevronLeftIcon from '@rahtab/ui/dist/icons/ChevronLeftIcon';
import { EntityTypeCode, useLogout, useViewerEntity } from '@rahtab/auth/lib/token-based-auth';
import { Image, StyleSheet, View } from 'react-native';
import { useState } from 'react';
import { RouteProp } from '@react-navigation/core';
import { RootStackType } from '../Router';
import { fixDateTime } from '@rahtab/system/lib/tools/string';
import { useSelector } from '../rahtab-redux';

const navButtons: NavigationButton[] = [
  {
    title: 'گذرواژه',
    svg: <PasswordIcon />,
  },
  {
    title: 'راهنما',
    svg: <HelpIcon />,
  },
];
const defaultProvider = require('assets/images/defaultProvider.png');
const Profile: React.FC<ProfileProps> = ({ route }) => {
  const [editInfoBtmSheet, setEditInfoBtmSheet] = useState(false);
  const { logout, logoutLoading } = useLogout();
  const profileInfo = useSelector((state) => state.viewer);
  const { viewerSelectedEntity } = useViewerEntity();
  return (
    <>
      {viewerSelectedEntity?.typeCode === EntityTypeCode.Provider ? (
        <BottomSheet visible={editInfoBtmSheet} onRequestClose={() => setEditInfoBtmSheet(false)}>
          <ButtonBase screenName={'EditInfo'} onPress={() => setEditInfoBtmSheet(false)}>
            <TextBase size={1.167}>ویرایش اطلاعات سازمانی</TextBase>
          </ButtonBase>
          <HorizontalLine style={{ marginTop: getSpacing() }} />
          <ButtonBase screenName={'EditLocationInfo'} onPress={() => setEditInfoBtmSheet(false)}>
            <TextBase size={1.167}>ویرایش اطلاعات مکانی</TextBase>
          </ButtonBase>
        </BottomSheet>
      ) : null}
      <ProfileScreen
        data={profileInfo}
        transparentLoading={logoutLoading}
        renderProfileCard={({ name, image, id, managerName, managerLastName, membershipDate }) => {
          return (
            <Card>
              <CardContainer>
                <View>
                  <Text margin="default" variant="title" color="primary">
                    {name}
                  </Text>
                  <Text color="description">
                    شناسه: <Text>{id}</Text>
                  </Text>
                  <Text color="description">
                    تاریخ عضویت: <Text>{fixDateTime(membershipDate, { displayTime: false })}</Text>
                  </Text>
                </View>
                <Text color="description" margin="none">
                  نماینده:{' '}
                  <Text color="primary">
                    {managerName} {managerLastName}
                  </Text>
                </Text>
              </CardContainer>
              {viewerSelectedEntity?.typeCode === EntityTypeCode.Provider ? (
                <ButtonBase onPress={() => setEditInfoBtmSheet(true)}>
                  <CardCaption style={StyleSheet.flatten([styles.captionView, styles.rowView])} color="primary">
                    <Text margin="none" color="white">
                      ویرایش اطلاعات
                    </Text>
                    <View style={{ transform: [{ rotate: '-90deg' }] }}>
                      <ChevronLeftIcon />
                    </View>
                  </CardCaption>
                </ButtonBase>
              ) : null}
            </Card>
          );
        }}
        navButtons={[]}
        onSignOut={() => {
          logout();
        }}
      />
    </>
  );
};

export default Profile;

const styles = StyleSheet.create({
  rowView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  captionView: {
    justifyContent: 'space-between',
  },
  profileImage: {
    height: 90,
    width: 90,
    borderRadius: getRadius(),
    borderWidth: getSpacing('border'),
    borderColor: Colors.border,
    marginRight: getSpacing(),
    marginBottom: getSpacing(),
  },
  imageContainer: {},
});

interface ProfileProps {
  route: RouteProp<RootStackType, 'Profile'>;
}
